<template>
  <SwapMenu2 :swapid="swapid" :title="title" margin="2">
     <template v-slot:menu>
     <li><a class="dropdown-item" @click="clearframe()">Clear</a></li>
     <li v-if="isfile"> <a class="dropdown-item" @click="savefile()"> Save </a></li>
     </template>
  </SwapMenu2>

  <div class="mb-3">
    <textarea class="form-control" rows=10 id="textarea01" name="textarea01" v-model="mydata">
    </textarea>
  </div>

</template>

<style scoped>
textarea {
    white-space: nowrap;
    overflow:    scroll;
    overflow-y:  scroll;
    overflow-x:  scroll;
    overflow:    -moz-scrollbars-horizontal;
}
</style>
<script>
   import SwapMenu2 from './SwapMenu2.vue' 
   import axios from 'axios'
   export default {
        name : 'TextArea',
        components : {
            SwapMenu2
        },
        props: {
            swapid : String
        },
        computed: {
            isfile() {
                return this.$parent.filepath != "" ;
            }
        },
        data() { return { 
                    mydata : "Please Wait Retrieving Data ...",
                    title : 'Edit Area'
                   } 
               },
        methods: {
            clearframe() {
                this.mydata = '' ;
                this.$parent.filepath = '' ;
            },
            savefile() {
                let req = "" ;
                try {
                  req = this.$store.getters.controller_url +
                  "/prosw/CFG/save?swapid=" + this.swapid + "&filename=" +
                  this.$parent.filepath
                }
                catch(err) {
                  return console.log (err) ;
                }
                this.$parent.filepath = ''
                let formData = new FormData();
                formData.append('textarea01', this.mydata);
                axios.post(req, formData, {
                    headers: {
                        'Pswtoken': this.$store.getters.pswtoken, 
                        'Content-Type': 'multipart/form-data'
                    }
                }).then ( (response) => { 
                    if (typeof response.data == "object") {
                        let obj = response.data ;
                        // let myarray = response.RESULT.split ("\n") ;
                        if (obj.RC != "00") 
                          this.mydata = "RC: " + obj.RC + ":" + obj.RDESC + "\r\n" 
                                + obj.RESULT ;
                        else 
                          this.mydata = "File Successfull Saved\r\n" + obj.RESULT
                    }
                    else
                        this.mydata = response.data ;
                })
                .catch ( err => { this.mydata = JSON.stringify(err) } ) 
            }
        },
   }
// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
</script>

